import HeaderDefault from '~/components/header-modules/HeaderDefault.vue';

export const HeaderModules = {
  HeaderDefaultRecord: HeaderDefault
};
